/**
 * Config Loader - Fetches web tracing config from backend at startup
 */

import type { WebTracingConfig } from './types';
import { LogLevel } from './types';

const DEFAULT_CONFIG: WebTracingConfig = {
  providers: {
    'web-console': { enabled: true, logLevel: LogLevel.DEBUG },
    'web-server': { enabled: true, logLevel: LogLevel.INFO1 },
    'web-popup': { enabled: true, logLevel: LogLevel.WARN },
  },
  componentLogLevels: {},
};

/**
 * Fetch web tracing config from the backend.
 * Returns null on failure (caller should use defaults).
 */
export async function loadWebTracingConfig(apiBaseUrl: string): Promise<WebTracingConfig | null> {
  try {
    const response = await fetch(`${apiBaseUrl}/web-tracing-config`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) return null;

    const json = await response.json();

    if (json.success && json.data) {
      return json.data as WebTracingConfig;
    }

    return null;
  } catch {
    // Silently fall back to defaults on network failure
    return null;
  }
}

export { DEFAULT_CONFIG };
